import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { useTranslation } from 'react-i18next';

export default function LocationSection() {
  const { t } = useTranslation();
  const { ref: refText, isVisible: visText } = useScrollReveal();
  const { ref: refMap, isVisible: visMap } = useScrollReveal();

  const neighborhoods = [
    { icon: 'ri-goblet-line', label: 'Dolder Grand Hotel', distance: '4 min.' },
    { icon: 'ri-store-line', label: 'Bahnhofstrasse', distance: '12 min.' },
    { icon: 'ri-flight-takeoff-line', label: 'Flughafen Zürich', distance: '25 min.' },
    { icon: 'ri-school-line', label: 'International School', distance: '8 min.' },
  ];

  return (
    <section id="location" className="py-32 bg-[#F5F3EF] overflow-hidden">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="gold-line" />
            <p className="font-sans text-[10px] tracking-[0.35em] uppercase text-[#B59A6A]">{t('location.label')}</p>
            <div className="gold-line" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1C1C1C]">{t('location.heading')}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div ref={refText} className={`reveal-left ${visText ? 'visible' : ''}`}>
            <p className="font-sans text-[15px] text-[#6B6460] leading-loose font-light mb-12">{t('location.text')}</p>
            <div className="space-y-0 border-t border-[#E5DDD3]">
              {neighborhoods.map((item) => (
                <div key={item.label} className="flex items-center justify-between py-5 border-b border-[#E5DDD3] group">
                  <div className="flex items-center gap-4">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${item.icon} text-[#B59A6A] text-base`} />
                    </div>
                    <span className="font-sans text-sm text-[#1C1C1C] font-light">{item.label}</span>
                  </div>
                  <span className="font-sans text-[11px] tracking-widest uppercase text-[#B59A6A]">{item.distance}</span>
                </div>
              ))}
            </div>
            <div className="mt-12 p-8 border border-[#E5DDD3] bg-white">
              <p className="font-serif text-lg italic text-[#1C1C1C] mb-3">&ldquo;{t('location.quote')}&rdquo;</p>
              <p className="font-sans text-[10px] tracking-widest uppercase text-[#B59A6A]">{t('location.quoteSource')}</p>
            </div>
          </div>

          <div ref={refMap} className={`reveal-right ${visMap ? 'visible' : ''}`}>
            <div className="relative w-full h-[540px] overflow-hidden border border-[#E5DDD3]">
              <iframe title="Zürichberg Lage" width="100%" height="100%"
                style={{ border: 0, filter: 'saturate(0.3) contrast(1.1) brightness(1.05)' }}
                loading="lazy" allowFullScreen
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5418.2!2d8.5735!3d47.3758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479aa39994b6db55%3A0x8d93f5e7e4c74aa!2sZ%C3%BCrichberg%2C%20Zurich!5e0!3m2!1sde!2sch!4v1234567890"
              />
              <div className="absolute bottom-6 left-6 bg-white/95 px-5 py-3">
                <p className="font-sans text-[10px] tracking-[0.25em] uppercase text-[#1C1C1C]">Zürichberg, 8044 Zürich</p>
                <p className="font-sans text-[10px] text-[#B59A6A] mt-0.5">{t('location.mapNote')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
